import { render, staticRenderFns } from "./PhoneInner.vue?vue&type=template&id=5f006d7e&scoped=true&"
import script from "./PhoneInner.vue?vue&type=script&lang=js&"
export * from "./PhoneInner.vue?vue&type=script&lang=js&"
import style0 from "./PhoneInner.vue?vue&type=style&index=0&id=5f006d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f006d7e",
  null
  
)

export default component.exports